import React from 'react'
import PropTypes from 'prop-types'
import { branch, isNilEmpty } from 'Utils'
import SvgIconAmenities, { PreLoadedSvgIconAmenities } from 'Components/SvgIconAmenities'

import {
  _Amenity, _SvgHolder, _CopyContDiv, _CopyContAmenityWithLink,
} from './styles'


export const FIBRE_STREAM = 'FibreStream Internet'
export const BEANFIELD_FIBRE = 'Beanfield Fibre Available'


// create link props using amenity icon name which is a unique string
export const amenityLinkProps = {
  'Beanfield Fibre Available': {
    title: 'Beanfield Fibre Available',
    url: 'https://www.beanfield.com/residential/' +
      '?utm_source=condos.ca&utm_medium=condos.ca_website&utm_campaign=building_amenities_link',
    gaAction: ['Beanfield clicked'],
    altTxt: 'Beanfield Internet',
  },
  'FibreStream Internet': {
    title: 'FibreStream Internet',
    url: 'https://www.fibrestream.ca/?utm_campaign=spring&utm_medium=link&utm_source=condosca',
    gaAction: ['FibreStream clicked'],
    altTxt: 'FibreStream Internet',
  },
}


const getAmenities = ({ amenities = [], xs = 6, sm = 6, md = 3, isPrint, gaSource }) => {
  if(isNilEmpty(amenities) || !Array.isArray(amenities)) return null
  return amenities.map(amenity => {
    if(!amenity) return null
    const amenityLink = amenityLinkProps[amenity.name]
    const Elem = !isPrint && amenityLink ? _CopyContAmenityWithLink : _CopyContDiv
    return (
      <_Amenity
        xs={xs}
        sm={sm}
        md={md}
        key={amenity.name}
        isprintstyle={isPrint}
        isLinkStyle={!isPrint && !!(amenityLink)}
      >
        {
          branch(
            amenity.icon_name,
            <_SvgHolder
              isPrint={isPrint}
            >
              {
                !isPrint ?
                  <SvgIconAmenities
                    name={'#icon-' + amenity.icon_name}
                    width="24"
                    height="24px"
                  />
                  :
                  <PreLoadedSvgIconAmenities name={'#icon-' + amenity.icon_name} width="24" height="24px" />

              }
            </_SvgHolder>,
          )
        }
        <Elem
          titlecomp="true"
          isPrint={isPrint}
          gaSource={gaSource}
          amenityLink={amenityLink}
        >
          {amenity.name}
        </Elem>
      </_Amenity>
    )
  })
}

getAmenities.propTypes = {
  amenities: PropTypes.shape({
    name: PropTypes.string,
    icon_name: PropTypes.string,
  }),
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  isPrint: PropTypes.bool,
  gaSource: PropTypes.string,
}

export default getAmenities
